<lib-filter-list [configService]="customerGungAddressConfigService"></lib-filter-list>